import React from 'react';
import moment from "moment";

import { VCCheckin, VCCheckout } from '../../../../../../../Common/Buttons/Icons';
import EmptyState from '../../../../../../../Common/EmptyState';
import { constants } from '../../../../../../../../Helpers/Constants';
import { Trans } from 'react-i18next';

export const VehicleActivity = (props) => {
    var activity_items = [];

    //Go through current bookings from newest to oldest, adding when vehicle is released, and returned 
    for (var i = props.vehicle_details.bookings.current.length - 1; i >= 0; --i) {
        if (props.vehicle_details.bookings.current[i].Released_On !== null) {
            activity_items.push(
                <div className="overlay_block_activity_timeline_item" key={"current_activity_" + i}>
                    <div className="overlay_timeline_item_header">
                        <div style={{display: 'flex', flex: 1, flexDirection: 'row'}}>
                            <a className="overlay_timeline_item_header_image_container" style={{marginLeft: "-15px"}}>
                                {VCCheckout('fill-primary')}
                            </a>
                            {
                                props.vehicle_details.bookings.current[i].Book_Type === constants.booking_type.service ?
                                    <div className="overlay_timeline_item_middle" style={{marginLeft: "-5px"}}>
                                        <div className="overlay_timeline_item_header_text">
                                            <Trans>Vehicle released for Servicing</Trans>
                                        </div>
                                        <div>
                                            <span className="overlay_timeline_item_subheader_text">{moment(props.vehicle_details.bookings.current[i].Start_Date).format("ddd MMM DD, YYYY")} - {moment(props.vehicle_details.bookings.current[i].End_Date).format("ddd MMM DD, YYYY")}</span>
                                        </div>
                                    </div>
                                :
                                    <div className="overlay_timeline_item_middle" style={{marginLeft: "-5px"}}>
                                        <div className="overlay_timeline_item_header_text">
                                            <Trans>Vehicle released to </Trans>{props.vehicle_details.bookings.current[i].First_Name} {props.vehicle_details.bookings.current[i].Last_Name}
                                        </div>
                                        <div>
                                            {
                                                props.vehicle_details.bookings.current[i].Title !== "" || props.vehicle_details.bookings.current[i].Title !== null ?
                                                    props.vehicle_details.bookings.current[i].Company !== "" && props.vehicle_details.bookings.current[i].Company !== null ? 
                                                        <span className="overlay_timeline_item_subheader_text">{props.vehicle_details.bookings.current[i].Title} at {props.vehicle_details.bookings.current[i].Company}</span>
                                                    :
                                                        <span className="overlay_timeline_item_subheader_text">{props.vehicle_details.bookings.current[i].Title}</span>
                                                :
                                                    props.vehicle_details.bookings.current[i].Company !== "" && props.vehicle_details.bookings.current[i].Company !== null ? 
                                                        <span className="overlay_timeline_item_subheader_text">{props.vehicle_details.bookings.current[i].Company}</span> 
                                                    :
                                                        <span className="overlay_timeline_item_subheader_text"></span>
                                            }
                                            <br />
                                            <span className="overlay_timeline_item_subheader_text">{moment(props.vehicle_details.bookings.current[i].Start_Date).format("ddd MMM DD, YYYY")} - {moment(props.vehicle_details.bookings.current[i].End_Date).format("ddd MMM DD, YYYY")}</span>
                                        </div>
                                    </div>
                            }
                        </div>
                        <div className="overlay_timeline_item_header_date">
                            {moment(props.vehicle_details.bookings.current[i].Released_On).format("MMM DD")}
                        </div>
                    </div>
                </div>
            )
        }
    }

    //Go through the past bookings and do the above, but go forward through them
    for (var i = props.vehicle_details.bookings.past.length - 1; i >= 0 ; --i) {
        if (props.vehicle_details.bookings.past[i].Returned_On !== null) {
            activity_items.push(
                <div className="overlay_block_activity_timeline_item" key={"past_returned_" + i}>
                    <div className="overlay_timeline_item_header">
                        <div style={{display: 'flex', flex: 1, flexDirection: 'row'}}>
                            <a className="overlay_timeline_item_header_image_container" style={{marginLeft: "-22px"}}>
                                {VCCheckin('fill-primary')}
                            </a>
                            {
                                props.vehicle_details.bookings.past[i].Book_Type === constants.booking_type.service ?
                                    <div className="overlay_timeline_item_middle" style={{marginLeft: "2px"}}>
                                        <div className="overlay_timeline_item_header_text">
                                            <Trans>Vehicle returned from Servicing</Trans>
                                        </div>
                                        <div>
                                            <span className="overlay_timeline_item_subheader_text">{moment(props.vehicle_details.bookings.past[i].Start_Date).format("ddd MMM DD, YYYY")} - {moment(props.vehicle_details.bookings.past[i].End_Date).format("ddd MMM DD, YYYY")}</span>
                                        </div>
                                    </div>
                                :
                                    <div className="overlay_timeline_item_middle" style={{marginLeft: "2px"}}>
                                        <div className="overlay_timeline_item_header_text">
                                            <Trans>Vehicle checked in at</Trans> {props.vehicle_details.bookings.past[i].vmh.Display_Name} - {props.vehicle_details.bookings.past[i].vmh.Display_City}
                                        </div>
                                        <div>
                                            <span className="overlay_timeline_item_subheader_text"><Trans>Checked in by</Trans> {props.vehicle_details.bookings.past[i].Returned_By}</span> <br />
                                            <span className="overlay_timeline_item_subheader_text"><Trans>Mileage</Trans>: {new Intl.NumberFormat('en-CA').format(props.vehicle_details.bookings.past[i].Odometer_Post)} KM</span> <br />
                                            <span className="overlay_timeline_item_subheader_text"><Trans>Fuel Level</Trans> {props.vehicle_details.bookings.past[i].Fuel_Post}/8</span> <br />
                                            {
                                                props.vehicle_details.bookings.past[i].Damage_Post === 0 ?
                                                    <span className="overlay_timeline_item_subheader_text"><Trans>No Damage</Trans></span>
                                                :
                                                    props.vehicle_details.bookings.past[i].Damage_Pre === 0 ?
                                                        <span className="overlay_timeline_item_subheader_text"><Trans>New Damage</Trans>: {props.vehicle_details.bookings.past[i].Damage_Notes_Post}</span>
                                                    :
                                                        props.vehicle_details.bookings.past[i].Damage_Post === 1 ?
                                                            <span className="overlay_timeline_item_subheader_text"><Trans>Old Damage</Trans>: {props.vehicle_details.bookings.past[i].Damage_Notes_Post}</span>
                                                        :
                                                            <div>
                                                                <span className="overlay_timeline_item_subheader_text"><Trans>New Damage</Trans>: {props.vehicle_details.bookings.past[i].Damage_Notes_Post.replace(props.vehicle_details.bookings.past[i].Damage_Notes_Pre, "")}</span><br />
                                                                <span className="overlay_timeline_item_subheader_text"><Trans>Previous Damage</Trans>: {props.vehicle_details.bookings.past[i].Damage_Notes_Pre}</span>
                                                            </div>
                                            }
                                        </div>
                                    </div>
                            }
                        </div>
                        <div className="overlay_timeline_item_header_date">
                            {moment(props.vehicle_details.bookings.past[i].Returned_On).format("MMM DD")}
                        </div>
                    </div>
                </div>
            )
        }

        if (props.vehicle_details.bookings.past[i].Released_On !== null) {
            activity_items.push(
                <div className="overlay_block_activity_timeline_item" key={"past_released_" + i}>
                    <div className="overlay_timeline_item_header">
                        <div style={{display: 'flex', flex: 1, flexDirection: 'row'}}>
                            <a className="overlay_timeline_item_header_image_container" style={{marginLeft: "-15px"}}>
                                {VCCheckout('fill-primary')}
                            </a>
                            {
                                props.vehicle_details.bookings.past[i].Book_Type === constants.booking_type.service ?
                                    <div className="overlay_timeline_item_middle" style={{marginLeft: "-5px"}}>
                                        <div className="overlay_timeline_item_header_text">
                                            <Trans>Vehicle released for Servicing</Trans>
                                        </div>
                                        <div>
                                            <span className="overlay_timeline_item_subheader_text">{moment(props.vehicle_details.bookings.past[i].Start_Date).format("ddd MMM DD, YYYY")} - {moment(props.vehicle_details.bookings.past[i].End_Date).format("ddd MMM DD, YYYY")}</span>
                                        </div>
                                    </div>
                                :
                                    <div className="overlay_timeline_item_middle" style={{marginLeft: "-5px"}}>
                                        <div className="overlay_timeline_item_header_text">
                                            <Trans>Vehicle released to</Trans> {props.vehicle_details.bookings.past[i].First_Name} {props.vehicle_details.bookings.past[i].Last_Name}
                                        </div>
                                        <div>
                                            {
                                                props.vehicle_details.bookings.past[i].Title !== "" || props.vehicle_details.bookings.past[i].Title !== null ?
                                                    props.vehicle_details.bookings.past[i].Company !== "" && props.vehicle_details.bookings.past[i].Company !== null ? 
                                                        <span className="overlay_timeline_item_subheader_text">{props.vehicle_details.bookings.past[i].Title} at {props.vehicle_details.bookings.past[i].Company}</span>
                                                    :
                                                        <span className="overlay_timeline_item_subheader_text">{props.vehicle_details.bookings.past[i].Title}</span>
                                                :
                                                    props.vehicle_details.bookings.past[i].Company !== "" && props.vehicle_details.bookings.past[i].Company !== null ? 
                                                        <span className="overlay_timeline_item_subheader_text">{props.vehicle_details.bookings.past[i].Company}</span> 
                                                    :
                                                        <span className="overlay_timeline_item_subheader_text"></span>
                                            }
                                            <br />
                                            <span className="overlay_timeline_item_subheader_text">{moment(props.vehicle_details.bookings.past[i].Start_Date).format("ddd MMM DD, YYYY")} - {moment(props.vehicle_details.bookings.past[i].End_Date).format("ddd MMM DD, YYYY")}</span>
                                        </div>
                                    </div>
                            }
                        </div>
                        <div className="overlay_timeline_item_header_date">
                            {moment(props.vehicle_details.bookings.past[i].Released_On).format("MMM DD")}
                        </div>
                    </div>
                </div>
            )
        }
    }

    if (activity_items.length > 0) {
        return activity_items;
    } else {
        return <div><EmptyState image = {props.settings.images.vehicle_placeholder_empty} text = "No Activity"/></div>
    }
}